<template>
    <div>
      <div class="container-fluid mt-3">

        <!-- Campo de búsqueda -->
        <!--b-row class="align-items-center mb-3">
          <b-col md="2" class="text-right">
            <label class="search-label"><strong>{{ $t('buscar') }} : </strong></label>
          </b-col>
          <b-col md="4">
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fas fa-search"></i>
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('buscar')"
                class="search-input rounded-left-none"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row-->
  
        <!-- Select de empresa -->
        <b-row v-if="empresasCliente && empresasCliente.length && !mostrarDetalle" class="align-items-center mb-3">
            <!-- Columna para el select de empresa -->
            <b-col md="3">
                <template v-if="showEmpresaBadge">
                  <span class="small text-muted mr-2">{{ $t('empresa') }}:</span>
                  <span class="badge badge-primary px-3 text-uppercase" style="display:inline-flex;align-items:center;height:32px;font-size:.85rem;">{{ nombreEmpresaSeleccionada || '—' }}</span>
                </template>
                <template v-else>
                  <el-select
                    v-model="empresaSeleccionada"
                    :placeholder="$t('placeholder_empresa')"
                    @change="onEmpresaSeleccionada"
                    style="width: 100%;"
                    filterable
                  >
                    <el-option
                      v-for="empresa in empresasCliente"
                      :key="empresa.id"
                      :label="empresa.nombre"
                      :value="empresa.id"
                    />
                  </el-select>
                </template>
            </b-col>

            <!-- Columna para el select de archivos cargados -->
            <b-col md="3" v-if="empresaSeleccionada && archivosLogsDisponibles && archivosLogsDisponibles.length">
              <el-select
  v-model="archivoSeleccionadoToken"
  filterable
  clearable
  :placeholder="$t('placeholder_archivo')"
  style="width: 100%;"
  @change="onArchivoTokenSeleccionado"
>
  <el-option
    v-for="archivo in archivosLogsDisponibles"
    :key="archivo.token"
    :label="archivo.nombreXLSX"
    :value="archivo.token"
  />
</el-select>
            </b-col>
<!-- cuando el seleccionado está en K -->
<b-col md="4" v-if="archivoSeleccionado && normalizeEstado(archivoSeleccionado.estadoFlujo) === 'K'">
  <b-button size="sm" variant="danger" class="mr-1" @click="mostrarError(archivoSeleccionado)">
    {{ $t('ver_error') || 'Ver error' }}
  </b-button>
</b-col>

        </b-row>
  
        <!-- Mensaje si aún no se ha seleccionado empresa -->
        <!--b-row v-if="!empresaSeleccionada && empresasCliente.length" class="align-items-center">
          <b-col md="6" class="text-center">
            <p class="text-muted">{{ $t('seleccione_una_empresa_primero') }}</p>
          </b-col>
        </b-row-->
      </div>
      <!-- Tabla de archivos cargados -->

<div v-if="archivosLogs.length && !mostrarDetalle" class="pb-6 pb-0 bg-gradient-success">
    <div class="my-2 container-fluid">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h5 class="text-primary mb-0">{{ $t('archivos_cargados') }}</h5>
      <b-button size="sm" variant="primary" @click="cargarLogsEmpresa(empresaSeleccionada)">
        <i class="fas fa-sync-alt mr-1"></i> {{ $t('refrescar') || 'Refrescar' }}
      </b-button>
    </div>
  <table class="table table-bordered table-hover table-sm tabla-archivos-cargados">
    <thead class="thead-light">
      <tr>
        <th style="width:40px;">#</th>
        <th class="th-ordenable" @click="ordenarPorArchivos('nombreXLSX')">
          <input class="th-search-input" v-model="filterColArchivos.nombreXLSX" @click.stop :placeholder="$t('buscar')" />
          <span class="th-label">{{ $t('nombre_archivo') }} <i :class="iconoOrdenArchivos('nombreXLSX')"></i></span>
        </th>
        <th class="th-ordenable text-center" @click="ordenarPorArchivos('estadoFlujoDesc')">
          <input class="th-search-input" v-model="filterColArchivos.estadoFlujoDesc" @click.stop :placeholder="$t('buscar')" />
          <span class="th-label">{{ $t('estado') }} <i :class="iconoOrdenArchivos('estadoFlujoDesc')"></i></span>
        </th>
        <th class="th-ordenable text-right" @click="ordenarPorArchivos('fechaRentabilizacion')">
          <input class="th-search-input" v-model="filterColArchivos.fechaRentabilizacion" @click.stop :placeholder="$t('buscar')" />
          <span class="th-label">{{ $t('fecha_rentabilizacion') }} (GMT 0) <i :class="iconoOrdenArchivos('fechaRentabilizacion')"></i></span>
        </th>
        <th class="th-ordenable text-center" @click="ordenarPorArchivos('tipoFlujo')">
          <input class="th-search-input" v-model="filterColArchivos.tipoFlujo" @click.stop :placeholder="$t('buscar')" />
          <span class="th-label">{{ $t('tipo_flujo') }} <i :class="iconoOrdenArchivos('tipoFlujo')"></i></span>
        </th>
        <th>{{ $t('accion') }}</th>
      </tr>
    </thead>
    <tbody>
  <tr v-for="(archivo, index) in processedArchivosLogs" :key="archivo.token">
    <td>{{ index + 1 }}</td>
    <td>{{ archivo.nombreXLSX }}</td>

    <!-- Estado -->
    <td class="text-center align-middle">
  <!-- 👇 Errores K/J/L como badge clickeable con nombre específico -->
  <button
    v-if="['K','J','L'].includes(normalizeEstado(archivo.estadoFlujo))"
    type="button"
    class="badge badge-danger badge-clickable"
    @click="mostrarError(archivo)"
    :title="archivo.estadoFlujoDesc || errorLabel(archivo.estadoFlujo)"
  >
    {{ archivo.estadoFlujoDesc || errorLabel(archivo.estadoFlujo) }}
  </button>

  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'P'" class="badge badge-danger">
    {{ archivo.estadoFlujoDesc || $t('sin_rentabilizacion') }}
  </span>
  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'S'" class="badge badge-warning">
    {{ archivo.estadoFlujoDesc || $t('en_proceso') }}
  </span>
  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'R'" class="badge badge-success">
    {{ archivo.estadoFlujoDesc || $t('rentabilizado') }}
  </span>
  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'C'" class="badge badge-info">
    {{ archivo.estadoFlujoDesc || $t('clusterizando') }}
  </span>
  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'T'" class="badge badge-primary">
    {{ archivo.estadoFlujoDesc || $t('clusterizado') || 'Clusterizado' }}
  </span>
  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'I'" class="badge badge-warning">
    {{ archivo.estadoFlujoDesc || $t('esperando_procesar') || 'Esperando procesar' }}
  </span>
  <!-- E-COMMERCE -->
  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'E'" class="badge badge-ecommerce">
    {{ archivo.estadoFlujoDesc || $t('ecommerce') || 'E-Commerce' }}
  </span>
  <!-- CATEGORIZACIÓN (G) -->
  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'G'" class="badge badge-info">
    {{ archivo.estadoFlujoDesc || $t('categorizando') || 'Categorization Process' }}
  </span>

  <span v-else class="badge badge-dark">{{ archivo.estadoFlujoDesc || $t('desconocido') }}</span>
</td>

    <!-- Fecha rentabilización -->
    <td class="text-right">
      {{ formatFechaGmt0(archivo.fechaRentabilizacion) }}
    </td>

    <!-- Tipo Flujo -->
    <td class="text-center align-middle">
      <span v-if="(archivo.tipoFlujo || '').trim() === 'FN'" class="badge badge-primary">{{ $t('tipo_flujo_fn') }}</span>
      <span v-else-if="(archivo.tipoFlujo || '').trim() === 'NR'" class="badge badge-warning">{{ $t('tipo_flujo_nr') }}</span>
      <span v-else-if="(archivo.tipoFlujo || '').trim() === 'DE'" class="badge badge-info">{{ $t('tipo_flujo_de') }}</span>
      <span v-else class="text-muted">—</span>
    </td>

    <!-- Acción -->
    <td>
  <!-- Estado P: Ejecutar.
       La rama se decide SOLO por el estado; el permiso y el tipo de flujo van dentro.
       Si se mezclan en esta condición, un archivo en P sin acción disponible (perfil de
       solo lectura, o flujo NR que no rentabiliza) se escapa de toda la cadena y termina
       cayendo en el v-else final, que lo pinta como "desconocido". -->
  <template v-if="normalizeEstado(archivo.estadoFlujo) === 'P'">
    <b-button
      v-if="puedeEscribir && !esFlujoDirectoCluster(archivo)"
      size="sm"
      variant="primary"
      @click="confirmarModalEjecucion(archivo)"
    >
      {{ $t('ejecutar') }}
    </b-button>
    <span v-else class="text-muted">—</span>
  </template>

<span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'S'" class="text-muted">
  {{ $t('en_proceso_rentabilizacion') }}
</span>

<span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'C'" class="text-muted">
  {{ $t('en_clusterizacion') }}
</span>

<span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'I'" class="text-muted">
  {{ $t('esperando_procesar_archivo') }}
</span>

  <!-- Estado K/J/L: errores -->
  <template v-else-if="['K','J','L'].includes(normalizeEstado(archivo.estadoFlujo))">
    <!-- Badge clickeable -->
    <button
      type="button"
      class="badge badge-danger badge-clickable mr-2"
      @click="mostrarError(archivo)"
      :title="errorLabel(archivo.estadoFlujo)"
    >
      {{ errorLabel(archivo.estadoFlujo) }}
    </button>
  </template>

<!-- Estados R/T -->
<template v-else-if="['R','T','E'].includes(normalizeEstado(archivo.estadoFlujo))">
  <b-button
    size="sm"
    class="btn-green mr-1"
    variant="info"
    @click="seleccionarArchivoDesdeTabla(archivo)"
  >
    {{ $t('ver_detalle') }}
  </b-button>

  <b-button
    v-if="puedeEscribir && normalizeEstado(archivo.estadoFlujo) === 'R'"
    size="sm"
    variant="primary"
    class="mr-1"
    @click="ejecutarClusterizar(archivo)"
  >
    {{ $t('clusterizar') || 'Clusterizar' }}
  </b-button>

  <b-button
    v-if="puedeEscribir"
    size="sm"
    variant="warning"
    @click="confirmarEditar(archivo)"
  >
    {{ $t('volver_adm_inventario') || 'Volver Adm. Inventario' }}
  </b-button>
</template>

<!-- Estado E (E-Commerce) -->
<!--template v-else-if="normalizeEstado(archivo.estadoFlujo) === 'E'">
  <b-button
    size="sm"
    class="btn-green mr-1"
    variant="info"
    @click="seleccionarArchivoDesdeTabla(archivo)"
  >
    {{ $t('ver_detalle') }}
  </b-button>

  <span class="text-muted ml-2">En proceso de E-Commerce</span>
</template-->

<span v-else class="text-muted">{{ $t('desconocido') }}</span>

  <!-- Eliminar Carga: disponible sin importar el estado -->
  <button
    v-if="puedeEscribir"
    class="btn btn-sm btn-danger ml-1"
    @click="confirmEliminarCarga(archivo)"
    :title="$t('eliminar_carga')"
  >
    {{ $t('eliminar_carga') }}
  </button>
</td>
  </tr>
</tbody>
  </table>
  </div>
  <b-modal
  id="modal-confirmar-ejecucion"
  :title="$t('confirmar_ejecucion')"
  @ok="confirmarEjecucion"
  :ok-title="$t('si_ejecutar')"
  :cancel-title="$t('cancelar')"
  ok-variant="danger"
>
  <p>{{ $t('seguro_ejecutar') }}</p>
</b-modal>
</div>

      <!-- Mensaje sin archivos -->
      <div v-if="empresaSeleccionada && archivosConsultados && !archivosLogs.length && !mostrarDetalle"
        class="my-4 text-center text-muted">
        <i class="fas fa-folder-open fa-2x mb-2 d-block"></i>
        {{ $t('sin_archivos_empresa') || 'Esta empresa no tiene archivos cargados.' }}
      </div>

      <b-container fluid class="mt-3">
        <b-row>
          <b-col>
            <div v-if="archivoSeleccionado && mostrarDetalle">

              <!--p><strong>Archivo seleccionado:</strong> {{ archivoSeleccionado }}</p-->
            

              <div v-if="estadoActualArchivo === 'R' || estadoActualArchivo === 'T' || estadoActualArchivo === 'E'" class="mb-5">
            <div v-if="cargandoRentabilizacion" class="text-center mt-6">
              <b-spinner small type="grow" label="Cargando..."></b-spinner>
              <span class="ml-2">{{ $t('cargando_datos_rentabilizacion') }}</span>
          </div>

  <div v-else>
<!-- Tabla de rentabilizaciones -->
<div v-if="estadoActualArchivo === 'R' || estadoActualArchivo === 'T' || estadoActualArchivo === 'E'" class="mb-5" style="padding-bottom:60px;">
    <div class="d-flex align-items-center flex-wrap w-100 mt-3" style="gap: 6px;">
  <button class="btn btn-sm btn-secondary" @click="mostrarDetalle = false">
    <i class="fas fa-arrow-left mr-1"></i> {{ $t('volver') || 'Volver' }}
  </button>
  <span class="badge badge-pill" style="background:#1de9b6;color:#fff;font-size:.75rem;padding:5px 10px;">
    {{ $t('total_valor_sugerido') }}: <strong>{{ totalValorSugerido }} USD</strong>
  </span>
  <span class="badge badge-pill" style="background:#5e72e4;color:#fff;font-size:.75rem;padding:5px 10px;">
    {{ $t('tasa_rentabilizacion_inventario') }}
  </span>
  <div class="input-group input-group-sm" style="width:90px;">
    <input
      id="porcentaje-input"
      v-model="porcentajeAjuste"
      type="number"
      :readonly="!puedeEscribir"
      class="form-control form-control-sm text-center"
      min="0" max="100" step="0.1"
      :placeholder="$t('ingrese_porcentaje')"
    />
    <div class="input-group-append">
      <span class="input-group-text" style="background:#5e72e4;color:#fff;border-color:#5e72e4;">%</span>
    </div>
  </div>
  <span class="badge badge-pill" style="background:#f5f5f5;color:#333;border:1px solid #ddd;font-size:.75rem;padding:5px 10px;">
    {{ valorCalculado }} USD
  </span>
  <button v-if="puedeEscribir" class="btn btn-green btn-sm shadow-sm" @click="confirmarGuardarRentabilizacion">
    <i class="fas fa-save mr-1"></i> {{ $t('guardar_cambios') }}
  </button>
  <button v-if="puedeEscribir && estadoActualArchivo === 'R'" class="btn btn-sm btn-secondary" @click="confirmarClusterizar">
    <i class="fas fa-project-diagram mr-1"></i> {{ $t('clusterizar') }}
  </button>
  <button class="btn btn-sm btn-primary" @click="fetchRentabilizacionData(currentPage)">
    <i class="fas fa-sync-alt mr-1"></i>
  </button>
  <button class="btn btn-sm btn-success" @click="exportarExcel" :title="$t('exportar_excel') || 'Exportar a Excel'">
    <i class="fas fa-file-excel"></i>
  </button>
</div>
<div class="d-flex align-items-center mb-3 mt-2" style="gap:12px;">
  <h4 class="text-primary mb-0" style="white-space:nowrap;">{{ $t('resultados_rentabilizacion') }}</h4>
  <span class="text-muted" style="font-size:.85rem;">
    <i class="fas fa-building mr-1"></i>
    <strong>{{ (empresasCliente.find(e => e.id === empresaSeleccionada) || {}).nombre || '—' }}</strong>
    <span class="mx-1">·</span>
    <i class="fas fa-file-excel mr-1"></i>
    <strong>{{ archivoSeleccionado && archivoSeleccionado.nombreXLSX || '—' }}</strong>
  </span>
</div>
<div class="tabla-scroll-fixed" ref="tablaScroll">
  <table class="table table-bordered table-sm table-fixed-columns">
    <thead :class="['thead-light', 'thead-sticky']">
      <tr>
        <th class="fixed-col" style="display: none;">#</th>
        <th @click="ordenar('sku')" class="fixed-col sticky-col left-col-2 th-ordenable">
          <input v-model="filterSkuInexlink" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">SKU-INEXLINK <i :class="obtenerIconoOrden('sku')"></i></span>
        </th>
        <th @click="ordenar('pn')" class="fixed-col sticky-col left-col-3 th-ordenable">
          <input v-model="filterPartText" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("part_number") }} <i :class="obtenerIconoOrden('pn')"></i></span>
        </th>
        <th @click="ordenar('nombre')" class="fixed-col sticky-col left-col-4 th-ordenable">
          <input v-model="filterNombreCorto" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("nombre_corto") }} <i :class="obtenerIconoOrden('nombre')"></i></span>
        </th>
        <th @click="ordenar('desc')" class="fixed-col sticky-col left-col-5 th-ordenable">
          <input v-model="filterNombreLargo" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("nombre_largo") }} <i :class="obtenerIconoOrden('desc')"></i></span>
        </th>
        <th @click="ordenar('brand')" class="fixed-col sticky-col left-col-6 th-ordenable">
          <input v-model="filterBrandName" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("brand_name") }} <i :class="obtenerIconoOrden('brand')"></i></span>
        </th>
        <th @click="ordenar('condicion')" class="fixed-col sticky-col left-col-7 th-ordenable">
          <input v-model="filterCondicion" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("condicion") }} <i :class="obtenerIconoOrden('condicion')"></i></span>
        </th>
        <th @click="ordenar('modelo')" class="scroll-col th-ordenable">
          <input v-model="filterModelo" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("modelo") }} <i :class="obtenerIconoOrden('modelo')"></i></span>
        </th>
        <!-- Columnas con scroll existentes -->
        <th @click="ordenar('horometro')" class="scroll-col th-ordenable">
          <input v-model="filterHorometro" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("horometro") }} <i :class="obtenerIconoOrden('horometro')"></i></span>
        </th>
        <th @click="ordenar('anoFabricacion')" class="scroll-col size-th th-ordenable">
          <input v-model="filterAnoFabricacion" @input="applyFilters(1)" @click.stop type="text" class="th-search-input"  />
          <span class="th-label">{{ $t("ano_fabricacion") }} <i :class="obtenerIconoOrden('anoFabricacion')"></i></span>
        </th>
        <th @click="ordenar('km')" class="scroll-col th-ordenable">
          {{ $t("kilometros") }} <i :class="obtenerIconoOrden('km')"></i>
        </th>
        <th @click="ordenar('cantidad')" class="scroll-col th-ordenable text-right">
          {{ $t("cantidad") }} <i :class="obtenerIconoOrden('cantidad')"></i>
        </th>
        <th @click="ordenar('precio')" class="scroll-col size-th th-ordenable text-right">
          {{ $t("precio") }} <i :class="obtenerIconoOrden('precio')"></i>
        </th>
        <!-- CAMPOS COMENTADOS
        <th class="scroll-col size-th">{{ $t("precio") }} (Usd)</th>
        <th class="scroll-col size-th">{{ $t("valor_total") }} (Usd)</th>
        <th class="scroll-col size-th">{{ $t("valor_sugerido")}} (Usd)</th>
        <th class="scroll-col size-th">{{ $t("valor_total_sugerido")}} (Usd)</th>
        <th class="scroll-col size-th" style="min-width: 130px;">{{ $t("tasa_retorno_esperada") }} %</th>
        -->
        <!-- NUEVAS COLUMNAS -->
        <th @click="ordenar('valSugGrupo')" class="scroll-col size-th th-ordenable">
          {{ $t("valor_sugerido_grupo") }} (Usd) <i :class="obtenerIconoOrden('valSugGrupo')"></i>
        </th>
        <th @click="ordenar('rangoGrupo')" class="scroll-col size-th th-ordenable">
          {{ $t("rango_grupo") }} (Usd) <i :class="obtenerIconoOrden('rangoGrupo')"></i>
        </th>
        <th @click="ordenar('valSugGeneral')" class="scroll-col size-th th-ordenable">
          {{ $t("valor_sugerido_general") }} (Usd) <i :class="obtenerIconoOrden('valSugGeneral')"></i>
        </th>
        <th @click="ordenar('rangoGeneral')" class="scroll-col size-th th-ordenable">
          {{ $t("rango_general") }} (Usd) <i :class="obtenerIconoOrden('rangoGeneral')"></i>
        </th>
        <th @click="ordenar('valSug')" class="scroll-col size-th th-ordenable">
          {{ $t("valor_sugerido") }} (Usd) <i :class="obtenerIconoOrden('valSug')"></i>
        </th>
        <th @click="ordenar('valSugTotal')" class="scroll-col size-th th-ordenable">
          {{ $t("valor_sugerido_total") }} (Usd) <i :class="obtenerIconoOrden('valSugTotal')"></i>
        </th>
        <th class="scroll-col" style="text-align:center;width:36px;"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in rentabilizacionData" :key="item.idMaterialETL">
        <td class="fixed-col" style="display: none;">{{ (currentPage - 1) * pageSize + index + 1 }}</td>
        <td class="fixed-col sticky-col left-col-2">{{ item.skuInexlink }}</td>
        <td class="fixed-col sticky-col left-col-3">{{ item.partNumber }}</td>
        <td class="fixed-col sticky-col left-col-4">{{ item.partName }}</td>
        <td class="fixed-col sticky-col left-col-5">
  <span
    class="text-primary text-truncate d-inline-block"
    style="cursor: pointer; max-width: 170px;"
    @click="abrirModalDetalle(item && item.detalles ? item.detalles : '')"
  >
    {{
      ((item && item.detalles) ? item.detalles : '').length > 50
        ? ((item && item.detalles) ? item.detalles : '').slice(0, 50) + '...'
        : ((item && item.detalles) ? item.detalles : '')
    }}
  </span>
</td>
        <td class="fixed-col sticky-col left-col-6">{{ item.brandName }}</td>
        <td class="fixed-col sticky-col left-col-7">{{ item.condicion }}</td>
        <td class="scroll-col">{{ item.modelo }}</td>
        <!-- Columnas con scroll existentes -->
        <td class="scroll-col text-right">{{ formatMilesCL(item.horometro) }}</td>
<td class="scroll-col text-right">{{ formatMilesCL(item.anoFabricacion) }}</td>
<td class="scroll-col text-right">{{ formatMilesCL(item.kilometros) }}</td>
        <td class="scroll-col text-right">{{ item.cantidad }}</td>
        <td class="scroll-col text-right">{{ formatPrecio(item.precio) }}</td>
        <!-- CAMPOS COMENTADOS
        <td class="scroll-col">
          <input
            :value="formatCurrency(item.precio)"
            @input="e => updateCurrencyValue(e.target.value, item, 'precio')"
            type="text"
            class="form-control inpt_result"
          />
        </td>
        <td class="scroll-col">
          <input
            :value="formatCurrency(item.valorTotal)"
            @input="e => updateCurrencyValue(e.target.value, item, 'valorTotal')"
            type="text"
            class="form-control inpt_result"
          />
        </td>
        <td class="scroll-col">
          <input
            :value="formatCurrency(item.valorSugerido)"
            @input="e => updateCurrencyValue(e.target.value, item, 'valorSugerido')"
            type="text"
            class="form-control inpt_result"
          />
        </td>
        <td class="scroll-col">
          <input
            :value="formatCurrency(item.valorTotalSugerido)"
            @input="e => updateCurrencyValue(e.target.value, item, 'valorTotalSugerido')"
            type="text"
            class="form-control inpt_result"
          />
        </td>
        <td class="scroll-col">
          <div class="input-group input-group-sm">
            <input
              :value="formatPercentage(item.tasaRetornoEsperada)"
              @input="e => updatePercentageValue(e.target.value, item)"
              type="text"
              class="form-control inpt_result text-right"
            />
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </td>
        -->
        <!-- NUEVAS CELDAS -->
        <td class="scroll-col text-right">
          {{ formatPrecio(item.valorSugeridoGrupo) }}
        </td>
        <td class="scroll-col text-right">
          {{ formatRangeCL(item.rangoGrupo) }}
        </td>
        <td class="scroll-col text-right">
         {{ formatPrecio(item.valorSugeridoGeneral) }}
        </td>
        <td class="scroll-col text-right">
          {{ formatRangeCL(item.rangoGeneral) }}
        </td>
        <td class="scroll-col">
          <input
            :value="valorSugeridoFormateado[item.idMaterialETL]"
            @keypress="e => onValorSugeridoKeypress(e, item)"
            @input="e => onValorSugeridoInput(e.target.value, item)"
            @blur="e => onValorSugeridoBlur(e.target.value, item)"
            type="text"
            :readonly="!puedeEscribir"
            class="form-control inpt_result text-right"
          />
</td>
  <td class="scroll-col text-right">
    {{ formatPrecio(item.valorTotalSugerido) }}
  </td>
  <td class="scroll-col" style="text-align:center;vertical-align:middle;">
    <el-tooltip placement="left" effect="dark">
      <template #content>
        <div style="font-size:0.8rem;line-height:1.8;min-width:240px;">
          <div><b>ID ETL:</b> {{ item.idMaterialETL }}</div>
          <div><b>SKU Inexlink:</b> {{ item.skuInexlink || '—' }}</div>
          <div><b>{{ $t('part_number') }}:</b> {{ item.partNumber || '—' }}</div>
          <div><b>{{ $t('nombre_corto') }}:</b> {{ item.partName || '—' }}</div>
          <div><b>{{ $t('nombre_largo') }}:</b> {{ item.detalles || '—' }}</div>
          <div><b>{{ $t('brand_name') }}:</b> {{ item.brandName || '—' }}</div>
          <div><b>{{ $t('condicion') }}:</b> {{ item.condicion || '—' }}</div>
          <div><b>{{ $t('categoria_inexlink') }}:</b> {{ item.categoriaInexlink || '—' }}</div>
          <div><b>{{ $t('modelo') }}:</b> {{ item.modelo || '—' }}</div>
          <div><b>{{ $t('ano_fabricacion') }}:</b> {{ item.anoFabricacion || '—' }}</div>
          <div><b>{{ $t('horometro') }}:</b> {{ item.horometro || '—' }}</div>
          <div><b>{{ $t('kilometros') }}:</b> {{ item.kilometros || '—' }}</div>
        </div>
      </template>
      <i class="fas fa-info-circle text-info" style="cursor:pointer;font-size:1rem;"></i>
    </el-tooltip>
  </td>
      </tr>
    </tbody>
  </table>
</div>
  <b-modal
  id="modal-detalle"
  :title="$t('detalle_completo')"
  size="lg"
  ok-only
  :ok-title="$t('cerrar')"
  hide-footer
>
  <p class="text-justify">{{ detalleSeleccionado }}</p>
</b-modal>

</div>
</div>
</div>

            </div>
          </b-col>
        </b-row>
      </b-container>

      <!-- Barra flotante de paginación (siempre visible en detalle) -->
      <div v-if="archivoSeleccionado && mostrarDetalle" class="pagination-floating-bar">
        <div class="d-flex align-items-center">
          <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
          <el-select v-model="pageSize" @change="buildPageFromAll(1)" style="width:80px">
            <el-option v-for="size in [20, 50, 100, 200]" :key="size" :label="size" :value="size" />
          </el-select>
        </div>
        <div class="d-flex align-items-center" style="gap:12px;">
          <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="buildPageFromAll(currentPage - 1)">
            <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
          </button>
          <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
            {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPages }}
          </span>
          <button class="btn btn-outline-primary btn-sm" :disabled="currentPage === totalPages" @click="buildPageFromAll(currentPage + 1)">
            {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
          </button>
          <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
            {{ totalCountAll }} {{ $t('items_totales') }}
          </span>
        </div>
        <div class="d-flex align-items-center" style="gap:6px;">
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
        </div>
      </div>
    </div>

  </template>
  
  <script>
  import materialService from "@/api/materialService";
  import utilsService from "@/api/utilsService";
  import { Select, Option } from 'element-ui';
  import * as XLSX from 'xlsx';
  import Swal from 'sweetalert2';
  
  export default {
    name: 'rentabilizacion-view',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    computed: {
      empresaSeleccionada: {
        get() { return this.$store.getters.empresaActiva; },
        set(val) { this.$store.dispatch('setEmpresaActiva', val); },
      },
      rol() {
        return (utilsService.getRol() || '').toLowerCase().trim();
      },
      showEmpresaBadge() {
        return (this.rol === 'cliente' || this.rol === 'ventas inex') && this.empresasCliente.length === 1;
      },
      nombreEmpresaSeleccionada() {
        const e = (this.empresasCliente || []).find(x => x.id === this.empresaSeleccionada);
        return e ? (e.nombre || '') : '';
      },
      processedArchivosLogs() {
        const f = this.filterColArchivos;
        let rows = (this.archivosLogs || []).filter(a => {
          for (const k in f) {
            const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
            if (!needle) continue;
            const cell = k === 'estadoFlujoDesc'
              ? (String(a.estadoFlujoDesc || '') + ' ' + String(a.estadoFlujo || '')).toLowerCase()
              : String(a[k] == null ? '' : a[k]).toLowerCase();
            if (!cell.includes(needle)) return false;
          }
          return true;
        });
        if (this.ordenColumnaArchivos) {
          const key = this.ordenColumnaArchivos;
          const dir = this.ordenDireccionArchivos === 'asc' ? 1 : -1;
          rows = [...rows].sort((a, b) => {
            let va = a[key] == null ? '' : a[key];
            let vb = b[key] == null ? '' : b[key];
            if (!isNaN(Date.parse(va)) && !isNaN(Date.parse(vb))) return (new Date(va) - new Date(vb)) * dir;
            va = String(va).toLowerCase();
            vb = String(vb).toLowerCase();
            return va < vb ? -dir : va > vb ? dir : 0;
          });
        }
        return rows;
      },
        totalCountAll() {
  return Array.isArray(this.filteredAllRentabilizacionData) ? this.filteredAllRentabilizacionData.length : 0;
},
        tasaRentabilizacionInventario() {
  const total = this.rentabilizacionData.reduce((acc, item) => {
    const val = parseFloat(item.valorTotal);
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  const sugerido = this.rentabilizacionData.reduce((acc, item) => {
    const val = parseFloat(item.valorSugerido);
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  if (total === 0) return '0%';

  const tasa = ((sugerido - total) / total) * 100;
  const fixed = tasa.toFixed(2);

  // 👇 Elimina decimales si es .00
  return fixed.endsWith('.00') ? `${parseInt(fixed)}%` : `${fixed}%`;
},
        archivosLogsDisponibles() {
  const excluidos = ['C', 'T', 'G', 'E'];
  return (this.archivosLogs || []).filter(a => {
    const estado = this.normalizeEstado(a.estadoFlujo || a.EstadoFlujo);
    return !excluidos.includes(estado);
  });
},
        totalValorSugerido() {
          return this.allRentabilizacionData.reduce((acc, item) => {
  const valor = parseFloat(item.valorTotalSugerido);
  return acc + (isNaN(valor) ? 0 : valor);
}, 0).toLocaleString('es-CL', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
},
estadoActualArchivo() {
  return this.normalizeEstado(
    this.archivoSeleccionado && this.archivoSeleccionado.estadoFlujo
  );
},
  valorCalculado() {
    if (!this.porcentajeAjuste || this.porcentajeAjuste === 0) {
      return 0;
    }
    
    const porcentajeDecimal = parseFloat(this.porcentajeAjuste) / 100;
    const valorTotalSugerido = this.allRentabilizacionData.reduce((acc, item) => {
      const valor = parseFloat(item.valorTotalSugerido);
      return acc + (isNaN(valor) ? 0 : valor);
    }, 0);

    const resultado = valorTotalSugerido * porcentajeDecimal;
    
    return resultado.toLocaleString('es-CL', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
  }
},
    data() {
        return {
          filterIdText: "",
          filterPartText: "",
          filterSkuInexlink: "",
          filterNombreCorto: "",
          filterNombreLargo: "",
          filterBrandName: "",
          filterCondicion: "",
          filterModelo: "",
          filterHorometro: "",
          filterAnoFabricacion: "",
          filterCategoriaInexlink: "",
          ordenColumna: null,
          ordenDireccion: "asc",
          filteredAllRentabilizacionData: [], // <- lista filtrada que alimenta la grilla
          pollTimerId: null,
          pollIntervalMs: 30000,
          valorSugeridoFormateado: {},
          archivoSeleccionadoToken: null,
            detalleSeleccionado: "",
            initialRentabilizacionData: [],
            archivoPendienteEjecucion: null,
            mostrarDetalle: false,
            cargandoRentabilizacion: false,
    lang: localStorage.getItem('language') || 'es',
    allRentabilizacionData: [], // todos los ítems cargados desde el backend (una sola vez)
    clientPageSize: 10,         // usa el mismo valor que pageSize si quieres (mantengo pageSize para UI)
    searchQuery: "",
    archivosLogs: [],
    filterColArchivos: { nombreXLSX: '', estadoFlujoDesc: '', fechaRentabilizacion: '', tipoFlujo: '' },
    ordenColumnaArchivos: null,
    ordenDireccionArchivos: 'asc',
    archivoSeleccionado: null,
    archivosConsultados: false,
    empresasCliente: [],
    rentabilizacionData: [],
    currentPage: 1,
    pageSize: 100,
    totalPages: 1,
    porcentajeAjuste: 0, // Agregar esta línea
  };
  
    },
    async mounted() {
  this.$store.dispatch('setSidebarCollapsed', false);
  window.addEventListener('scroll', this._onWindowScroll, { passive: true });
  try {
    const resp = await materialService.getEmpresasAsociadas();

    console.log("🔹 Respuesta cruda getEmpresasAsociadas:", resp);

    // Evita optional chaining:
    const empresasRaw = Array.isArray(resp) ? resp
      : (resp && Array.isArray(resp.data)) ? resp.data
      : (resp && Array.isArray(resp.items)) ? resp.items
      : (resp && Array.isArray(resp.resultado)) ? resp.resultado
      : [];

    // Utilidad local para elegir el primer campo disponible
    function pickFirst(obj, keys) {
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (obj && obj[k] != null) return obj[k];
      }
      return undefined;
    }

    this.empresasCliente = empresasRaw
      .map(function (e) {
        return {
          id: pickFirst(e, ['id', 'empresaId', 'Id', 'ID']),
          nombre: pickFirst(e, ['nombre', 'razonSocial', 'Nombre', 'name'])
        };
      })
      .filter(function (e) { return e.id && e.nombre; });

    console.log("🔹 Empresas asociadas (normalizadas):", this.empresasCliente);

    // Pre-seleccionar empresa si viene por query param (?empresa=<id>)
    const empresaQuery = this.$route && this.$route.query && this.$route.query.empresa;
    if (empresaQuery) {
      const idEmpresa = parseInt(empresaQuery, 10);
      if (!isNaN(idEmpresa)) {
        this.empresaSeleccionada = idEmpresa;
        await this.onEmpresaSeleccionada();
      }
    } else if (this.empresaSeleccionada) {
      await this.onEmpresaSeleccionada();
    }
  } catch (error) {
    console.error("Error cargando empresas del cliente:", error);
    this.empresasCliente = [];
  }
    },
  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this.stopPollingEstado();
    window.removeEventListener('scroll', this._onWindowScroll);
  },
    methods: {
      formatFechaGmt0(valor) {
        if (!valor) return 'No disponible';
        // No se usa Date(): el valor ya viene en GMT 0 desde la BD y Date()
        // lo reinterpretaría como hora local del navegador, corriendo la hora.
        // Se extrae el texto tal cual (YYYY-MM-DD HH:mm) sin conversión de zona horaria.
        const match = String(valor).match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
        return match ? `${match[1]} ${match[2]}` : String(valor);
      },
      _onWindowScroll() {
  const wrapper = this.$refs.tablaScroll;
  if (!wrapper) return;
  const thead = wrapper.querySelector('thead');
  if (!thead) return;
  const top = wrapper.getBoundingClientRect().top;
  if (top < 0) {
    thead.style.transform = `translateY(${-top}px)`;
    thead.style.zIndex = '100';
  } else {
    thead.style.transform = '';
    thead.style.zIndex = '';
  }
},

      scrollTabla(dir) {
  const el = this.$refs.tablaScroll;
  if (!el) return;
  const px = 300;
  if (dir === 'left')   el.scrollBy({ left: -px, behavior: 'smooth' });
  if (dir === 'right')  el.scrollBy({ left:  px, behavior: 'smooth' });
  if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
  if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
},

      ordenarPorArchivos(col) {
        if (this.ordenColumnaArchivos === col) {
          this.ordenDireccionArchivos = this.ordenDireccionArchivos === 'asc' ? 'desc' : 'asc';
        } else {
          this.ordenColumnaArchivos = col;
          this.ordenDireccionArchivos = 'asc';
        }
      },
      iconoOrdenArchivos(col) {
        if (this.ordenColumnaArchivos !== col) return 'fas fa-sort text-muted';
        return this.ordenDireccionArchivos === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
      },

      normalizeEstado(v) {
  return String(v == null ? '' : v).trim().toUpperCase();
},
// "NR" (Directo a Cluster): el archivo salta la rentabilización y se clusteriza
// directamente, así que no se le ofrece la acción de rentabilizar.
esFlujoDirectoCluster(archivo) {
  return String((archivo && (archivo.tipoFlujo || archivo.TipoFlujo)) || '').trim().toUpperCase() === 'NR';
},

errorLabel(estadoRaw) {
  const e = this.normalizeEstado(estadoRaw);
  if (e === 'J') return this.$t('error_categorizacion') || 'Error Categorización';
  if (e === 'L') return this.$t('error_clusterizacion') || 'Error Clusterización';
  return this.$t('error_rentabilizacion') || 'Error Rentabilización';
},

firstDefined() {
  for (let i = 0; i < arguments.length; i++) {
    const v = arguments[i];
    if (v !== null && v !== undefined) return v;
  }
  return null;
},

async mostrarError(archivo) {
  try {
    const title = this.errorLabel(archivo && (archivo.estadoFlujo || archivo.EstadoFlujo));
    const fallback = 'No hay detalles de error disponibles.';

    // 1️⃣ Busca primero en el propio objeto
    let localMsg = this.firstDefined(
      archivo && archivo.mensajeError,
      archivo && archivo.MensajeError,
      archivo && archivo.error,
      archivo && archivo.Error,
      archivo && archivo.mensajeErrorCategoria,
      archivo && archivo.MensajeErrorCategoria,
      archivo && archivo.mensajeErrorClusterizacion,
      archivo && archivo.MensajeErrorClusterizacion,
      archivo && archivo.detalle && (archivo.detalle.mensajeError || archivo.detalle.MensajeError),
      archivo && archivo.detalle && (archivo.detalle.mensaje || archivo.detalle.Mensaje),
      null
    );
    if (typeof localMsg === 'string') localMsg = localMsg.trim();

    // 2️⃣ Si no tiene mensaje, busca la fila en la lista por token/Token
    if (!localMsg && archivo && (archivo.token || archivo.Token)) {
      const fila = this.archivosLogs.find(a => (a.token || a.Token) === (archivo.token || archivo.Token));
      if (fila) {
        localMsg = this.firstDefined(fila.MensajeError, fila.mensajeError, fila.Error, fila.error, null);
        if (typeof localMsg === 'string') localMsg = localMsg.trim();
      }
    }

    // 3️⃣ Si ya hay mensaje, muestra el modal directamente
    if (localMsg) {
      await Swal.fire({
        icon: 'error',
        title,
        html: `<pre style="text-align:left;white-space:pre-wrap;">${localMsg}</pre>`
      });
      return;
    }

    // 4️⃣ Si no hay mensaje, intenta con getFileLog
    const resp = await materialService.getFileLog(archivo.token || archivo.Token);
    let serverMsg = this.firstDefined(
      resp && resp.MensajeError,
      resp && resp.mensajeError,
      resp && resp.detalle && (resp.detalle.mensajeError || resp.detalle.MensajeError),
      ''
    );
    if (typeof serverMsg === 'string') serverMsg = serverMsg.trim();

    await Swal.fire({
      icon: 'error',
      title,
      html: `<pre style="text-align:left;white-space:pre-wrap;">${serverMsg || fallback}</pre>`
    });
  } catch (e) {
    console.error('mostrarError()', e);
    await Swal.fire({
      icon: 'error',
      title: this.errorLabel(archivo && (archivo.estadoFlujo || archivo.EstadoFlujo)),
      text: this.$t('error_detalle') || 'No se pudo obtener el detalle del error.'
    });
  }
},

async confirmEliminarCarga(log) {
  if (!this.puedeEscribir) return;
  const token = (log && (log.token || log.Token)) || null;
  if (!token) return;

  // Verificar si hay fichas publicadas antes de permitir eliminar
  try {
    const apiBase = process.env.VUE_APP_API_URL || '';
    const checkResp = await fetch(
      `${apiBase}/api/cluster/getFichasPublicadasPorToken/${encodeURIComponent(token)}`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
          'Accept': 'application/json'
        }
      }
    );

    if (checkResp.ok) {
      const data = await checkResp.json();
      if (Array.isArray(data) && data.length > 0) {
        // Solo el nombre del archivo (sin duplicar): pueden ser cientos de fichas
        const nombresArchivos = [...new Set(data.map(f => f.nombreXLSX || '—'))];
        const items = nombresArchivos.map(n => `<li style="margin-bottom:4px"><b>${n}</b></li>`).join('');

        const result = await Swal.fire({
          icon: 'error',
          title: this.$t('no_permitido'),
          html: `<p>${this.$t('archivo_fichas_publicadas')}</p>
                 <ul style="text-align:left;padding-left:1.2rem">${items}</ul>
                 <p style="margin-top:8px"><b>${this.$t('revise_modulo_ecommerce')}</b></p>`,
          confirmButtonText: this.$t('entendido'),
          showCancelButton: true,
          cancelButtonText: this.$t('ir_a_ficha'),
          cancelButtonColor: '#17a2b8'
        });

        if (result.dismiss === Swal.DismissReason.cancel) {
          sessionStorage.setItem('lecturaVentasEstado', JSON.stringify({
            empresaSeleccionada: this.empresaSeleccionada,
            tokenActual: token,
            archivoSeleccionado: log
          }));
          window.open('/lectura-ventas-inventario', '_blank');
        }
        return; // bloquear la eliminación
      }
    }
  } catch (e) {
    console.error('Error al verificar fichas publicadas:', e);
  }

  // Sin fichas publicadas: continuar con la confirmación original
  const resp = await Swal.fire({
    title: this.$t('confirmar_eliminar_carga'),
    text: this.$t('texto_eliminar_carga'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    confirmButtonText: this.$t('eliminar_carga'),
    cancelButtonText: this.$t('cancelar') || 'Cancelar',
    reverseButtons: true
  });
  if (!resp.isConfirmed) return;

  try {
    await materialService.eliminarCarga(token);

    this.archivosLogs = (this.archivosLogs || []).filter(x => (x.token || x.Token) !== token);
    if (this.archivoSeleccionado && (this.archivoSeleccionado.token || this.archivoSeleccionado.Token) === token) {
      this.archivoSeleccionado = null;
    }

    Swal.fire({ icon: 'success', title: this.$t('eliminado'), timer: 1800, showConfirmButton: false });
  } catch (e) {
    const msg = (e && e.response && e.response.data && (e.response.data.error || e.response.data)) || (e && e.message) || '';
    Swal.fire({
      icon: 'error',
      title: this.$t('error') || 'Error',
      text: (this.$t('no_se_pudo_eliminar') || 'No se pudo eliminar.') + (msg ? ` (${msg})` : '')
    });
  }
},
      getIdDB(x) {
  // Sólo Id de BD (acepta Id o id por si cambia el casing)
  const raw = this.firstDefined(x && x.Id, x && x.id);
  return raw != null ? Number(raw) : '';
},
      normalizeTxt(v) {
  return String(v == null ? "" : v)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
},

ordenar(columna) {
  if (this.ordenColumna === columna) {
    this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
  } else {
    this.ordenColumna = columna;
    this.ordenDireccion = 'asc';
  }
  this.applyFilters(1);
},

obtenerIconoOrden(columna) {
  if (this.ordenColumna !== columna) return 'fas fa-sort text-muted';
  return this.ordenDireccion === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
},

applyFilters(goToPage = null) {
  let rows = Array.isArray(this.allRentabilizacionData) ? this.allRentabilizacionData : [];

  const n = (v) => this.normalizeTxt(v);
  const needles = {
    id:       n(this.filterIdText),
    sku:      n(this.filterSkuInexlink),
    pn:       n(this.filterPartText),
    nombre:   n(this.filterNombreCorto),
    desc:     n(this.filterNombreLargo),
    brand:    n(this.filterBrandName),
    condicion:n(this.filterCondicion),
    modelo:   n(this.filterModelo),
    horo:     n(this.filterHorometro),
    ano:      n(this.filterAnoFabricacion),
    catInex:  n(this.filterCategoriaInexlink),
  };

  const hasFilter = Object.values(needles).some(v => !!v);

  if (hasFilter) {
    const chk = (needle, val) => !needle || n(String(val == null ? '' : val)).includes(needle);
    rows = rows.filter(r => {
      const rawId = this.firstDefined(r && r.Id, r && r.id, r && r.idProducto, r && r.idMaterialETL);
      return (
        chk(needles.id,       rawId) &&
        chk(needles.sku,      r.skuInexlink) &&
        chk(needles.pn,       r.partNumber) &&
        chk(needles.nombre,   r.partName) &&
        chk(needles.desc,     r.detalles) &&
        chk(needles.brand,    r.brandName) &&
        chk(needles.condicion,r.condicion) &&
        chk(needles.modelo,   r.modelo) &&
        chk(needles.horo,     r.horometro) &&
        chk(needles.ano,      r.anoFabricacion) &&
        chk(needles.catInex,  r.categoriaInexlink)
      );
    });
  }

  // Ordenar columna
  if (this.ordenColumna) {
    const dir = this.ordenDireccion === 'asc' ? 1 : -1;
    const col = this.ordenColumna;
    rows = rows.slice().sort((a, b) => {
      if (col === 'id') return dir * (this.pickRowId(a) - this.pickRowId(b));
      const fieldMap = {
        sku: 'skuInexlink', pn: 'partNumber', nombre: 'partName', desc: 'detalles',
        brand: 'brandName', condicion: 'condicion', modelo: 'modelo',
        horometro: 'horometro', anoFabricacion: 'anoFabricacion', categoriaInexlink: 'categoriaInexlink',
        km: 'kilometros', cantidad: 'cantidad',
        valSugGrupo: 'valorSugeridoGrupo', rangoGrupo: 'rangoGrupo',
        valSugGeneral: 'valorSugeridoGeneral', rangoGeneral: 'rangoGeneral',
        valSug: 'valorSugerido', valSugTotal: 'valorTotalSugerido'
      };
      const f = fieldMap[col] || col;
      const rawA = a[f] == null ? '' : a[f];
      const rawB = b[f] == null ? '' : b[f];
      const numA = parseFloat(rawA);
      const numB = parseFloat(rawB);
      if (!isNaN(numA) && !isNaN(numB)) return dir * (numA - numB);
      return dir * String(rawA).toLowerCase().localeCompare(String(rawB).toLowerCase());
    });
  } else {
    rows.sort((a, b) => this.pickRowId(a) - this.pickRowId(b));
  }

  this.filteredAllRentabilizacionData = rows;
  this.buildPageFromAll(goToPage || 1);
},
      valueToDbString(val) {
  const n = this.toNumberCL(val); // quita . y , y parsea
  return n == null ? null : String(n);  // "1000" o null
},
      formatRangeCL(value) {
  if (value === null || value === undefined || value === '') return '';

  // Si viene como string con números y separadores
  if (typeof value === 'string') {
    // extrae números (permite coma y punto)
    const nums = value.match(/-?\d+(?:[\.,]\d+)?/g);
    if (nums && nums.length >= 2) {
      const a = this.toNumberCL(nums[0]);
      const b = this.toNumberCL(nums[1]);
      return `[${this._fmtMoneyCL(a)}, ${this._fmtMoneyCL(b)}]`;
    }
    return value; // si no se puede parsear, muestra tal cual
  }

  // Si viene como array [min, max]
  if (Array.isArray(value) && value.length >= 2) {
    return `[${this._fmtMoneyCL(this.toNumberCL(value[0]))}, ${this._fmtMoneyCL(this.toNumberCL(value[1]))}]`;
  }

  // Si viene como objeto {min, max} / {desde, hasta}
if (typeof value === 'object') {
  const a = this.firstDefined(value.min, value.desde, value.Min, value.Desde);
  const b = this.firstDefined(value.max, value.hasta, value.Max, value.Hasta);
  if (a !== null && a !== undefined && b !== null && b !== undefined) {
    return `[${this._fmtMoneyCL(this.toNumberCL(a))}, ${this._fmtMoneyCL(this.toNumberCL(b))}]`;
  }
}

  // Si llega un número simple, formatea como dinero
  if (typeof value === 'number') {
    return this._fmtMoneyCL(value);
  }

  return '';
},
_fmtMoneyCL(n) {
  const num = this.toNumberCL(n);
  if (num == null) return '';
  return num.toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
},
      toNumberCL(val) {
  if (typeof val === 'number') return isNaN(val) ? null : val;
  const s = String(val == null ? '' : val).replace(/\./g, '').replace(/,/g, '').trim();
  const n = parseFloat(s);
  return isNaN(n) ? null : n;
},
      parsePrecioLocale(val) {
  if (val === null || val === undefined || val === '') return null;
  if (typeof val === 'number') return isNaN(val) ? null : val;
  let s = String(val).trim();
  if (this.lang === 'en') {
    s = s.replace(/,/g, '');
  } else {
    s = s.replace(/\./g, '').replace(',', '.');
  }
  const n = parseFloat(s);
  return isNaN(n) ? null : n;
},
      formatMilesCL(value) {
  if (value === null || value === undefined || value === "") return "";
  const num = parseFloat(value);
  if (isNaN(num)) return "";
  return num.toLocaleString("es-CL"); // 👈 separador de miles con "."
},
pickRowId(x) {
  // Toma Id o id (casing variable). Si no existe, empuja al final (Infinity).
  const raw = this.firstDefined(x && x.Id, x && x.id);
  const n = raw != null ? Number(raw) : NaN;
  return Number.isFinite(n) ? n : Infinity;
},

sortAllAscById() {
  if (!Array.isArray(this.allRentabilizacionData)) return;
  this.allRentabilizacionData.sort((a, b) => this.pickRowId(a) - this.pickRowId(b));
},

buildPageFromAll: function (page) {
  var p = page || 1;
  var size = this.pageSize;

  // 👇 siempre desde la lista filtrada
  const base = Array.isArray(this.filteredAllRentabilizacionData)
    ? this.filteredAllRentabilizacionData
    : [];

  var start = (p - 1) * size;
  var end = start + size;

  this.rentabilizacionData = base.slice(start, end);
  this.currentPage = p;
  this.totalPages = Math.max(1, Math.ceil(base.length / size));

  // refresca formateos visibles
  this.valorSugeridoFormateado = {};
  for (var i = 0; i < this.rentabilizacionData.length; i++) {
    var it = this.rentabilizacionData[i];
    this.valorSugeridoFormateado[it.idMaterialETL] = this.formatPrecio(it.valorSugerido);
  }
},
      exportarExcel() {
  const rows = Array.isArray(this.filteredAllRentabilizacionData)
    ? this.filteredAllRentabilizacionData
    : [];
  if (!rows.length) {
    this.$notify && this.$notify({ type: 'warning', message: 'No hay datos para exportar.' });
    return;
  }

  const headers = [
    'SKU-INEXLINK',
    this.$t('part_number'),
    this.$t('nombre_corto'),
    this.$t('nombre_largo'),
    this.$t('brand_name'),
    this.$t('condicion'),
    this.$t('modelo'),
    this.$t('horometro'),
    this.$t('ano_fabricacion'),
    this.$t('kilometros'),
    this.$t('cantidad'),
    this.$t('precio'),
    `${this.$t('valor_sugerido_grupo')} (USD)`,
    `${this.$t('rango_grupo')} (USD)`,
    `${this.$t('valor_sugerido_general')} (USD)`,
    `${this.$t('rango_general')} (USD)`,
    `${this.$t('valor_sugerido')} (USD)`,
    `${this.$t('valor_sugerido_total')} (USD)`,
  ];

  const data = rows.map(r => [
    r.skuInexlink        || '',
    r.partNumber         || '',
    r.partName           || '',
    r.detalles           || '',
    r.brandName          || '',
    r.condicion          || '',
    r.modelo             || '',
    r.horometro          != null ? r.horometro          : '',
    r.anoFabricacion     != null ? r.anoFabricacion     : '',
    r.kilometros         != null ? r.kilometros         : '',
    r.cantidad           != null ? r.cantidad           : '',
    r.precio             != null ? this.formatPrecio(r.precio) : '',
    r.valorSugeridoGrupo != null ? this.formatPrecio(r.valorSugeridoGrupo) : '',
    r.rangoGrupo         || '',
    r.valorSugeridoGeneral != null ? this.formatPrecio(r.valorSugeridoGeneral) : '',
    r.rangoGeneral       || '',
    r.valorSugerido      != null ? this.formatPrecio(r.valorSugerido) : '',
    r.valorTotalSugerido != null ? this.formatPrecio(r.valorTotalSugerido) : ''
  ]);

  const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Rentabilización');

  const empresa = (this.empresasCliente.find(e => e.id === this.empresaSeleccionada) || {}).nombre || 'empresa';
  const archivo = (this.archivoSeleccionado && this.archivoSeleccionado.nombreXLSX
    ? this.archivoSeleccionado.nombreXLSX.replace(/\.xlsx?$/i, '')
    : 'archivo');
  const fecha = new Date().toISOString().slice(0, 10);
  const nombre = `Rentabilizacion_${empresa}_${archivo}_${fecha}.xlsx`.replace(/[/\\?%*:|"<>]/g, '_');

  XLSX.writeFile(wb, nombre);
},

      verArchivo(archivo) {
  if (!archivo || !archivo.token) return;
  try {
    this.$router.push({ path: `/materialesResultFile/${archivo.token}` });
  } catch (_) {
    window.location.href = `/materialesResultFile/${archivo.token}`;
  }
},

    async ejecutarClusterizar(archivo) {
      if (!this.puedeEscribir) return;
  const tok = archivo && (archivo.token || archivo.Token);
  if (!tok) return;

  const res = await Swal.fire({
    title: this.$t('confirmar_clusterizar') || '¿Iniciar clusterización?',
    text: this.$t('confirmar_clusterizar_texto') || 'Se enviará el archivo a clusterización.',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: this.$t('clusterizar') || 'Clusterizar',
    cancelButtonText: this.$t('cancelar') || 'Cancelar',
  });

  if (!res.isConfirmed) return;

  try {
    const resp = await materialService.updateEstadoFlujo(tok, 'C');
    if (resp && (resp.success === true || resp.Success === true)) {
      const idx = (this.archivosLogs || []).findIndex(a => (a.token || a.Token) === tok);
      if (idx !== -1) {
        this.archivosLogs.splice(idx, 1, { ...this.archivosLogs[idx], estadoFlujo: 'C', EstadoFlujo: 'C' });
      }
      this.$notify && this.$notify({ type: 'success', message: this.$t('clusterizando') || 'Clusterización iniciada' });
    } else {
      this.$notify && this.$notify({ type: 'warning', message: 'No se pudo iniciar la clusterización' });
    }
  } catch (e) {
    console.error(e);
    this.$notify && this.$notify({ type: 'error', message: 'Error al solicitar clusterización' });
  }
},


    /**
     * Da de baja todo lo asociado al archivo: fichas, clusters del resumen y ranking.
     * Solo se ofrece al volver a Administración de Inventario, porque ese camino rehace
     * rentabilización y clusterización desde cero y esos clusters dejan de corresponder.
     */
    async eliminarFichasYClustersDelArchivo(token) {
      const confirm = await Swal.fire({
        icon: 'warning',
        title: this.$t('confirmar_eliminar_fichas'),
        text: this.$t('accion_irreversible'),
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar_igualmente'),
        confirmButtonColor: '#d33',
        cancelButtonText: this.$t('cancelar'),
        reverseButtons: true
      });
      if (!confirm.isConfirmed) return false;

      try {
        const apiBase = process.env.VUE_APP_API_URL || '';
        const resp = await fetch(
          `${apiBase}/api/cluster/desactivarFichasPublicadasPorToken/${encodeURIComponent(token)}`,
          {
            method: 'PUT',
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
              'Accept': 'application/json'
            }
          }
        );
        if (!resp.ok) throw new Error(await resp.text());
        return true;
      } catch (e) {
        console.error('Error al desactivar fichas y clusters:', e);
        Swal.fire({
          icon: 'error',
          title: this.$t('error') || 'Error',
          text: this.$t('no_se_pudo_eliminar') || 'No se pudo eliminar.'
        });
        return false;
      }
    },

      async confirmarEditar(archivo) {
        if (!this.puedeEscribir) return;
  const token = archivo && String(archivo.token || '').trim();
  if (!token) return;

  // Verificar si hay fichas publicadas antes de permitir volver
  try {
    const apiBase = process.env.VUE_APP_API_URL || '';
    const resp = await fetch(
      `${apiBase}/api/cluster/getFichasPublicadasPorToken/${encodeURIComponent(token)}`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
          'Accept': 'application/json'
        }
      }
    );

    if (resp.ok) {
      const data = await resp.json();
      if (Array.isArray(data) && data.length > 0) {
        // Solo el nombre del archivo (sin duplicar): pueden ser cientos de fichas
        const nombresArchivos = [...new Set(data.map(f => f.nombreXLSX || '—'))];
        const items = nombresArchivos.map(n => `<li style="margin-bottom:4px"><b>${n}</b></li>`).join('');

        // SweetAlert2 v9 no tiene showDenyButton: el tercer botón va dentro del html.
        let eliminarIgualmenteClicked = false;
        const result = await Swal.fire({
          icon: 'error',
          title: this.$t('no_permitido'),
          html: `<p>${this.$t('archivo_fichas_publicadas')}</p>
                 <ul style="text-align:left;padding-left:1.2rem">${items}</ul>
                 <p style="margin-top:8px"><b>${this.$t('revise_modulo_ecommerce')}</b></p>
               <button id="btnEliminarIgualmente" type="button" class="btn btn-sm btn-danger mt-2">
                 ${this.$t('eliminar_igualmente')}
               </button>`,
          confirmButtonText: this.$t('entendido'),
          showCancelButton: true,
          cancelButtonText: this.$t('ir_a_ficha'),
          cancelButtonColor: '#17a2b8',
          onOpen: (popup) => {
            const btn = popup.querySelector('#btnEliminarIgualmente');
            if (btn) {
              btn.addEventListener('click', () => { eliminarIgualmenteClicked = true; Swal.close(); });
            }
          }
        });

        // Liberado el archivo, se reintenta la misma acción: la validación ya no bloquea.
        if (eliminarIgualmenteClicked) {
          const liberado = await this.eliminarFichasYClustersDelArchivo(token);
          if (liberado) return this.confirmarEditar(archivo);
          return;
        }

        if (result.dismiss === Swal.DismissReason.cancel) {
          sessionStorage.setItem('lecturaVentasEstado', JSON.stringify({
            empresaSeleccionada: this.empresaSeleccionada,
            tokenActual: token,
            archivoSeleccionado: archivo
          }));
          window.open('/lectura-ventas-inventario', '_blank');
        }
        return; // bloquear la acción
      }
    }
  } catch (e) {
    console.error('Error al verificar fichas publicadas:', e);
  }

  // Sin fichas publicadas: continuar con la confirmación original
  const res = await Swal.fire({
    title: this.$t('confirmar_volver_adm_inventario') || '¿Volver a la Administración de Materiales?',
    text: this.$t('texto_volver_adm_inventario') || 'Volverá a la Administración de Materiales. Deberá ejecutar el proceso de RENTABILIDAD nuevamente.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.$t('volver_adm_inventario') || 'Volver Adm. Inventario',
    cancelButtonText: this.$t('cancelar') || 'Cancelar',
    reverseButtons: true
  });

  if (!res.isConfirmed) return;
  await this.editarArchivo(archivo);
},

async editarArchivo(archivo) {
  if (!archivo || !archivo.token) {
    this.$notify && this.$notify({ type: 'warning', message: this.$t('archivo_invalido') });
    return;
  }

  const token = archivo.token;

  // (Opcional) alerta corta informativa previa a la navegación
  this.$notify && this.$notify({ type: 'info', message: this.$t('reabriendo_archivo_edicion') });

  try {
    // 1) Cambiar estado a P en backend
    const resp = await materialService.updateEstadoFlujo(token, 'P');

    if (!(resp && (resp.success === true || resp.Success === true))) {
      this.$notify && this.$notify({ type: 'warning', message: this.$t('no_se_pudo_cambiar_estado_p') });
      return;
    }

    // 2) Actualizar tabla local
    const idx = this.archivosLogs.findIndex(a => a.token === token);
    if (idx !== -1) {
      this.$set(this.archivosLogs, idx, {
        ...this.archivosLogs[idx],
        estadoFlujo: 'P'
      });
    }

    // 3) Detener polling de R/S si estaba activo
    this.stopPollingEstado();

    // 4) Navegar a la vista de edición de Materiales
    // Ajusta la ruta si tu app usa un name distinto.
    try {
      // Preferimos navegar por path para evitar depender del name:
      this.$router.push({ path: `/materialesResultFile/${token}` });
      // Si tienes una ruta con name, podrías usar:
      // this.$router.push({ name: 'materiales-result', params: { token } });
    } catch (_) {
      // fallback mínimo
      window.location.href = `/materialesResultFile/${token}`;
    }
  } catch (error) {
    console.error(error);
    this.$notify && this.$notify({ type: 'error', message: this.$t('error_preparar_edicion') });
  }
},
      async confirmarClusterizar() {
        if (!this.puedeEscribir) return;
  // Verifica estado válido
  if (!this.archivoSeleccionado || this.estadoActualArchivo !== 'R') {
    this.$notify && this.$notify({ type: 'warning', message: 'Debe haber un archivo rentabilizado (estado R) para clusterizar.' });
    return;
  }

  // Detecta cambios sin guardar
  let hayCambios = false;
  try {
    const cambiosPendientes = this.getModifiedRentabilizacionRows();
    hayCambios = Array.isArray(cambiosPendientes) && cambiosPendientes.length > 0;
  } catch (_) {}

  const titulo = hayCambios
    ? this.$t('cambios_sin_guardar')
    : this.$t('enviar_clusterizacion');
  const texto = hayCambios
    ? this.$t('cambios_detectados_clusterizar')
    : this.$t('seguro_clusterizar');

  const result = await Swal.fire({
    title: titulo,
    text: texto,
    icon: 'warning',
    showCancelButton: true,
    showDenyButton: hayCambios,
    confirmButtonText: this.$t('clusterizar'),
    denyButtonText: this.$t('guardar_cambios_primero'),
    cancelButtonText: this.$t('cancelar'),
    reverseButtons: true
  });

  if (result.isDenied) {
    // Guardar primero
    await this.confirmarGuardarRentabilizacion();
    return;
  }

  if (!result.isConfirmed) return;

  // Opcional: loader mientras se actualiza estado
  Swal.fire({
    title: this.$t('enviando_clusterizacion'),
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    await this.enviarACluster();
  } finally {
    Swal.close();
  }
},
      async enviarACluster() {
  const archivoTarget = this.archivoSeleccionado;

  if (!archivoTarget || !archivoTarget.token) {
    this.$notify && this.$notify({ type: 'warning', message: 'Debe seleccionar un archivo rentabilizado antes de clusterizar.' });
    return;
  }

  try {
    const tokenArchivo = archivoTarget.token;
    const nuevoEstado = "C"; // Estado de Clusterización

    // ⛳ Cambiamos el estado en backend
    const response = await materialService.updateEstadoFlujo(tokenArchivo, nuevoEstado);

    if (response && (response.success === true || response.Success === true)) {
      this.$notify && this.$notify({ type: 'success', message: 'Archivo enviado a clusterización (Estado "C").' });

      // 🔄 Forzar estado local a C en la tabla (UX inmediato)
      const idx = this.archivosLogs.findIndex(a => a.token === tokenArchivo);
      if (idx !== -1) {
        this.$set(this.archivosLogs, idx, {
          ...this.archivosLogs[idx],
          estadoFlujo: "C",
        });
      }

      // Redirigir a clusterización
      try { this.$router.push({ path: '/clusterizacion' }); } catch (_) {}
    } else {
      this.$notify && this.$notify({ type: 'warning', message: 'No se pudo actualizar a estado "C".' });
    }
  } catch (error) {
    console.error(error);
    this.$notify && this.$notify({ type: 'error', message: 'Error al enviar a clusterización.' });
  }
},
      startPollingEstado() {
  this.stopPollingEstado();
  const token = this.archivoSeleccionado && this.archivoSeleccionado.token;
  if (!token) return;

  // 🔹 Primer tick inmediato para no esperar al intervalo
  this.tickPollEstado();

  // 🔹 MUY IMPORTANTE: conservar el this con una arrow
  this.pollTimerId = setInterval(() => this.tickPollEstado(), this.pollIntervalMs);
},

stopPollingEstado() {
  if (this.pollTimerId) {
    clearInterval(this.pollTimerId);
    this.pollTimerId = null;
  }
},

async tickPollEstado() {
  try {
    const token = this.archivoSeleccionado && this.archivoSeleccionado.token;
    if (!token) return;

    const resp = await materialService.getEstadoFlujoArchivo(token);

    // Normaliza estructura posible del backend/axios
    const data = (resp && resp.data) ? resp.data : resp;

    // ✅ Consideramos OK si hay success=true o si al menos viene algun estado
    var hasEstado = !!(data && (typeof data.estadoFlujo !== 'undefined' || typeof data.EstadoFlujo !== 'undefined'));
    var ok = !!(data && ((data.success === true || data.Success === true) || hasEstado));

    var nuevo = '';
if (data) {
  let tmp = null;
  if (typeof data.estadoFlujo !== 'undefined' && data.estadoFlujo !== null) {
    tmp = data.estadoFlujo;
  } else if (typeof data.EstadoFlujo !== 'undefined' && data.EstadoFlujo !== null) {
    tmp = data.EstadoFlujo;
  }
  nuevo = this.normalizeEstado(tmp);
}

    var nuevaFecha = null;
    if (data) {
      if (typeof data.fechaRentabilizacion !== 'undefined' && data.fechaRentabilizacion !== null) {
        nuevaFecha = data.fechaRentabilizacion;
      } else if (typeof data.FechaRentabilizacion !== 'undefined' && data.FechaRentabilizacion !== null) {
        nuevaFecha = data.FechaRentabilizacion;
      }
    }

    const msgErr = this.firstDefined(
  data && data.mensajeError,
  data && data.MensajeError,
  null
);

    console.log('🩺 Poll EstadoFlujo', { token, ok, nuevo, nuevaFecha, raw: resp });
    if (!ok) return;

    const prev = (this.archivoSeleccionado && this.archivoSeleccionado.estadoFlujo) || '';

    // 🔹 Actualiza seleccionado (incluye mensajeError)
this.archivoSeleccionado = {
  ...this.archivoSeleccionado,
  estadoFlujo: nuevo,
  fechaRentabilizacion: nuevaFecha,
  mensajeError: msgErr || (this.archivoSeleccionado && this.archivoSeleccionado.mensajeError) || ''
};

// 🔹 Actualiza fila en la tabla (incluye mensajeError)
const idx = this.archivosLogs.findIndex(a => a.token === token);
if (idx !== -1) {
  this.$set(this.archivosLogs, idx, {
    ...this.archivosLogs[idx],
    estadoFlujo: nuevo,
    fechaRentabilizacion: nuevaFecha,
    mensajeError: msgErr || (this.archivosLogs[idx] && this.archivosLogs[idx].mensajeError) || ''
  });
}

// Si pasó a error (K/J/L), detiene el polling
if (['K','J','L'].includes(nuevo)) this.stopPollingEstado();

    // 🔹 Si cambió a R, carga resultados
    if (prev !== nuevo && (nuevo === 'R' || nuevo === 'T')) {
  await this.fetchRentabilizacionData(1);
}
  } catch (e) {
    console.warn('Polling EstadoFlujo error: ', e);
  }
},
      ensureRentRow(row) {
  return {
    ...row,
    detalles: row && row.detalles ? String(row.detalles) : '',
    valorSugerido: row && row.valorSugerido != null ? row.valorSugerido : 0,
    cantidad: row && row.cantidad != null ? row.cantidad : 0,
    valorSugeridoGeneralTotal:
      (row && row.valorSugerido != null ? +row.valorSugerido : 0) *
      (row && row.cantidad != null ? +row.cantidad : 0)
  };
},
onValorSugeridoKeypress(e, item) {
  // El teclado numérico solo tiene ".", pero en español el decimal es ",".
  // Se intercepta la tecla y se inserta "," en su lugar para que no se
  // interprete como separador de miles al parsear.
  if (this.lang !== 'en' && e.key === '.') {
    e.preventDefault();
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const value = input.value;
    const newValue = value.slice(0, start) + ',' + value.slice(end);
    input.value = newValue;
    input.selectionStart = input.selectionEnd = start + 1;
    this.onValorSugeridoInput(newValue, item);
  }
},
onValorSugeridoInput(value, item) {
  // Mientras el usuario escribe se deja el texto tal cual (sin reformatear en cada tecla,
  // porque forzar el decimal en cada input arrastra ceros: 5 -> 5,0 -> 5,00 -> ...).
  this.valorSugeridoFormateado[item.idMaterialETL] = value;
  const parsed = this.parsePrecioLocale(value);

  if (parsed != null) {
    item.valorSugerido = parsed;
    const qty = this.toNumberCL(item.cantidad);
    item.valorTotalSugerido = (qty != null ? parsed * qty : 0);

    this.actualizarValorTotal(item);
    item.showGuardar = true;
  } else {
    item.valorSugerido = '';
    item.valorTotalSugerido = '';
  }
},
onValorSugeridoBlur(value, item) {
  const parsed = this.parsePrecioLocale(value);
  this.valorSugeridoFormateado[item.idMaterialETL] = parsed != null ? this.formatPrecio(parsed) : '';
},
actualizarValorTotal(item) {
  const sugerido = this.toNumberCL(item.valorSugerido);
  const cantidad = this.toNumberCL(item.cantidad);

  if (sugerido != null && cantidad != null) {
    item.valorTotalSugerido = sugerido * cantidad;
  } else {
    item.valorTotalSugerido = null;
  }

  item.showGuardar = true;
},
      async onArchivoTokenSeleccionado(token) {
  const encontrado = this.archivosLogs.find(a => a.token === token);
  if (encontrado) {
    this.archivoSeleccionado = encontrado;
    await this.onArchivoSeleccionado();
    this.startPollingEstado(); 
  }
},
      formatDecimal(value) {
  if (value === null || value === undefined || value === "") return "";
  const num = parseFloat(value);
  if (isNaN(num)) return "";
  const txt = num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  // Si termina en .00 lo dejamos sin decimales
  return txt.endsWith(".00") ? txt.slice(0, -3) : txt;
},
        abrirModalDetalle(detalle) {
  this.detalleSeleccionado = detalle;
  this.$bvModal.show('modal-detalle');
},
        formatPercentage(value) {
  if (value === null || value === undefined || value === '') return '';
  const number = parseFloat(value);
  if (isNaN(number)) return '';
  return Number.isInteger(number) ? number : number.toFixed(2).replace(/\.?0+$/, '');
},
updatePercentageValue(value, item) {
  // Elimina el signo % y espacios
  const normalized = String(value).replace('%', '').trim();
  const parsed = parseFloat(normalized);

  // Guarda solo el número (ej: 12.5)
  item.tasaRetornoEsperada = isNaN(parsed) ? '' : parsed;
  item.showGuardar = true;
},
formatCurrency(value) {
  if (value === null || value === undefined || value === '') return '';
  const number = parseFloat(value);
  if (isNaN(number)) return '';
  return number.toLocaleString('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
},
formatPrecio(precio) {
  if (precio === null || precio === undefined || precio === '') return '';
  const numero = Number(precio);
  if (Number.isNaN(numero)) return '';
  const locale = this.lang === 'en' ? 'en-US' : 'es-CL';
  return numero.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
},
updateCurrencyValue(value, item, field) {
  const normalized = String(value).replace(/\./g, '').replace(/,/g, '');
  const parsed = parseFloat(normalized);
  item[field] = isNaN(parsed) ? '' : parsed;
  item.showGuardar = true;
},
async guardarRentabilizacion(cambios) {
  try {
    const token = this.archivoSeleccionado ? this.archivoSeleccionado.token : null;
    await materialService.updateMaterialETL(token, cambios);

    Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), "success");

    await this.fetchRentabilizacionData();
    this.initialRentabilizacionData = JSON.parse(JSON.stringify(this.rentabilizacionData));
  } catch (error) {
    console.error("Error al guardar cambios:", error);
    Swal.fire("Error", this.$t('no_se_pudo_guardar_cambios'), "error");
  }
},
  async confirmarGuardarRentabilizacion() {
    if (!this.puedeEscribir) return;
  const cambios = this.getModifiedRentabilizacionRows();
  if (!cambios.length) {
    Swal.fire(this.$t('informacion'), this.$t('no_hay_cambios'), "info");
    return;
  }

  const confirm = await Swal.fire({
    title: this.$t('guardar_cambios_pregunta'),
    text: this.$t('se_guardaran_cambios'),
    icon: "question",
    showCancelButton: true,
    confirmButtonText: this.$t('si_guardar'),
    cancelButtonText: this.$t('cancelar'),
  });

  if (!confirm.isConfirmed) return;

  // 👇 EJECUTAR EL SERVICIO DE PORCENTAJE ANTES DE GUARDAR
  if (this.porcentajeAjuste && this.porcentajeAjuste > 0) {
    try {
        const responsePorc = await materialService.updatePorcentajeRentEsperado(
        this.archivoSeleccionado.token, 
        this.porcentajeAjuste
      );

      if (responsePorc.success) {
        console.log("✅ Porcentaje aplicado correctamente");
      } else {
        console.warn("⚠️ Error al aplicar porcentaje:", responsePorc);
      }
    } catch (error) {
      console.error("❌ Error ejecutando updatePorcentajeRentEsperado:", error);
    }
  }

  await this.guardarRentabilizacion(cambios);
},
getModifiedRentabilizacionRows() {
  return this.rentabilizacionData
    .filter((item, index) => {
      const original = this.initialRentabilizacionData[index] || {};

      // Descompón en flags para evitar el "return ( ... || ... )" gigante
      const chPrecio                = String(item.precio)                   !== String(original.precio);
      const chValorTotal            = String(item.valorTotal)               !== String(original.valorTotal);
      const chValorSugerido         = String(item.valorSugerido)            !== String(original.valorSugerido);
      const chValorTotalSugerido    = String(item.valorTotalSugerido)       !== String(original.valorTotalSugerido);
      const chTasaRetorno           = String(item.tasaRetornoEsperada)      !== String(original.tasaRetornoEsperada);

      const chValSugGrupo           = String(item.valorSugeridoGrupo)       !== String(original.valorSugeridoGrupo);
      const chRangoGrupo            = String(item.rangoGrupo)               !== String(original.rangoGrupo);
      const chValSugGrupoTotal      = String(item.valorSugeridoGrupoTotal)  !== String(original.valorSugeridoGrupoTotal);
      const chRangoGeneral          = String(item.rangoGeneral)             !== String(original.rangoGeneral);
      const chValSugGeneral         = String(item.valorSugeridoGeneral)     !== String(original.valorSugeridoGeneral);
      const chValSugGeneralTotal    = String(item.valorSugeridoGeneralTotal)!== String(original.valorSugeridoGeneralTotal);

      const changed =
        chPrecio ||
        chValorTotal ||
        chValorSugerido ||
        chValorTotalSugerido ||
        chTasaRetorno ||
        chValSugGrupo ||
        chRangoGrupo ||
        chValSugGrupoTotal ||
        chRangoGeneral ||
        chValSugGeneral ||
        chValSugGeneralTotal;

      return changed;
    })
    .map(item => ({
      IdMaterialETL: item.idMaterialETL,
      BrandName: item.brandName,
      PartNumber: item.partNumber,
      PartName: item.partName,
      CategoriaOrigen: item.categoriaOrigen,
      Detalles: item.detalles,
      Cantidad: item.cantidad,
      Categoria_MM: item.categoria_MM,
      Clase: item.clase,
      CategoriaInexlink: item.categoriaInexlink,

      // Enviamos números como string “plain” para el backend
      ValorSugerido:        this.valueToDbString(item.valorSugerido),
      ValorTotalSugerido:   this.valueToDbString(item.valorTotalSugerido),

      Modelo: item.modelo,
      Horometro: item.horometro,
      AnoFabricacion: item.anoFabricacion,
      Kilometros: item.kilometros,

      ValorSugeridoGrupo:        item.valorSugeridoGrupo != null ? String(item.valorSugeridoGrupo) : '',
      RangoGrupo:                item.rangoGrupo != null ? String(item.rangoGrupo) : '',
      ValorSugeridoGrupoTotal:   item.valorSugeridoGrupoTotal != null ? String(item.valorSugeridoGrupoTotal) : '',
      RangoGeneral:              item.rangoGeneral != null ? String(item.rangoGeneral) : '',
      ValorSugeridoGeneral:      item.valorSugeridoGeneral != null ? String(item.valorSugeridoGeneral) : '',
      ValorSugeridoGeneralTotal: item.valorSugeridoGeneralTotal != null ? String(item.valorSugeridoGeneralTotal) : ''
    }));
},
  confirmarModalEjecucion(archivo) {
    if (!this.puedeEscribir || this.esFlujoDirectoCluster(archivo)) return;
  this.archivoPendienteEjecucion = archivo;
  this.$bvModal.show('modal-confirmar-ejecucion');
},

confirmarEjecucion() {
  if (this.archivoPendienteEjecucion) {
    this.ejecutarArchivo(this.archivoPendienteEjecucion);
    this.archivoPendienteEjecucion = null;
  }
},
async seleccionarArchivoDesdeTabla(archivo) {
  this.archivoSeleccionado = archivo;
  this.mostrarDetalle = true;
  this.onArchivoSeleccionado();

  const response = await materialService.getFileLog(archivo.token);
  this.porcentajeAjuste = response.porcentajeRentabilidadEsperado || 0;

  this.startPollingEstado();

  // Cargar datos inmediatamente si ya está en R o T
  if (this.estadoActualArchivo === 'R' || this.estadoActualArchivo === 'T' || this.estadoActualArchivo === 'E') {
    await this.fetchRentabilizacionData(1);
  }
},
async fetchRentabilizacionData(page = 1) {
  this.cargandoRentabilizacion = true;
  try {
    const token = this.archivoSeleccionado ? this.archivoSeleccionado.token : null;
    if (!token) {
      this.allRentabilizacionData = [];
      this.buildPageFromAll(1);
      return;
    }

    // 1) Carga en BLOQUES grandes para minimizar requests (ajusta según soporte del backend)
    //   - Si tu API soporta pageSize alto (p.ej. 1000), usa ese valor para traer todo en pocas llamadas.
    //   - Si no, quedará en loop por páginas normales.
    const BIG_PAGE = 1000;
    var pageIndex = 1;
    var keepGoing = true;
    var all = [];

    while (keepGoing) {
      const resp = await materialService.getResultETL(token, pageIndex, BIG_PAGE, this.lang);
      const items = Array.isArray(resp.items) ? resp.items : [];
      const total = typeof resp.totalCount === 'number' ? resp.totalCount : (all.length + items.length);

      // acumula
      for (var i = 0; i < items.length; i++) all.push(items[i]);

      // condición de salida:
      if (all.length >= total || items.length < BIG_PAGE) {
        keepGoing = false;
      } else {
        pageIndex += 1;
      }
    }

    this.allRentabilizacionData = all;

// Orden global por ID
this.sortAllAscById();

// Inicializa la lista filtrada con TODO
this.filteredAllRentabilizacionData = this.allRentabilizacionData.slice();
this.filteredAllRentabilizacionData.sort((a, b) => this.pickRowId(a) - this.pickRowId(b));

// Construye la página (respeta “page” recibido)
this.buildPageFromAll(page);

// snapshot inicial…
this.initialRentabilizacionData = JSON.parse(JSON.stringify(this.rentabilizacionData));
  } catch (error) {
    console.error("Error al obtener datos rentabilizados:", error);
    this.allRentabilizacionData = [];
    this.totalCountAll = 0;
    this.buildPageFromAll(1);
  } finally {
    this.cargandoRentabilizacion = false;
  }
},
async ejecutarArchivo(archivo = null) {
  const archivoTarget = archivo || this.archivoSeleccionado;

  if (!archivoTarget) {
    this.$notify({ type: 'warning', message: 'Debe seleccionar un archivo antes de ejecutar' });
    return;
  }

  try {
    const tokenArchivo = archivoTarget.token;
    const nuevoEstado = "S";

    const response = await materialService.updateEstadoFlujo(tokenArchivo, nuevoEstado);

    if (response && (response.success === true || response.Success === true)) {
      //this.$notify({ type: 'success', message: 'Estado actualizado a "S" correctamente' });

      // 🔹 Forzar estado local a S inmediatamente (UX más fluida)
      const idx = this.archivosLogs.findIndex(a => a.token === tokenArchivo);
      if (idx !== -1) {
        this.$set(this.archivosLogs, idx, {
          ...this.archivosLogs[idx],
          estadoFlujo: "S",
          // fechaRentabilizacion la dejará el backend cuando pase a R
        });
      }

      // 🔹 Si el ejecutado NO era el seleccionado, lo seleccionamos
      if (!this.archivoSeleccionado || this.archivoSeleccionado.token !== tokenArchivo) {
        const fila = this.archivosLogs.find(a => a.token === tokenArchivo);
        if (fila) this.archivoSeleccionado = { ...fila };
      } else {
        // Si ya era el seleccionado, actualizamos su estado local
        this.archivoSeleccionado = {
          ...this.archivoSeleccionado,
          estadoFlujo: "S"
        };
      }

      // 🔹 Arrancar/continuar el polling para esperar el cambio a R
      this.startPollingEstado();

      // (Opcional) refrescar estado desde API para confirmar
      try {
        const estadoActual = await materialService.getEstadoFlujoArchivo(tokenArchivo);
        const data = estadoActual && estadoActual.data ? estadoActual.data : estadoActual;
        const estado = (data && (data.estadoFlujo || data.EstadoFlujo)) || "S";
        const fecha  = (data && (data.fechaRentabilizacion || data.FechaRentabilizacion)) || null;

        // Actualiza fila y seleccionado con lo más reciente
        const i2 = this.archivosLogs.findIndex(a => a.token === tokenArchivo);
        if (i2 !== -1) {
          this.$set(this.archivosLogs, i2, {
            ...this.archivosLogs[i2],
            estadoFlujo: estado,
            fechaRentabilizacion: fecha
          });
        }
        if (this.archivoSeleccionado && this.archivoSeleccionado.token === tokenArchivo) {
          this.archivoSeleccionado = {
            ...this.archivoSeleccionado,
            estadoFlujo: estado,
            fechaRentabilizacion: fecha
          };
        }
      } catch (_) {}
    } else {
      this.$notify({ type: 'warning', message: 'No se pudo actualizar el estado' });
    }
  } catch (error) {
    console.error(error);
    this.$notify({ type: 'error', message: 'Error al actualizar el estado del archivo' });
  }
},
async onArchivoSeleccionado() {
  if (!this.archivoSeleccionado) return;

  try {
    const response = await materialService.getEstadoFlujoArchivo(this.archivoSeleccionado.token);
    if (response && (response.success || response.Success)) {
      this.archivoSeleccionado = {
        ...this.archivoSeleccionado,
        estadoFlujo: this.normalizeEstado(response.estadoFlujo || response.EstadoFlujo),
        fechaRentabilizacion: response.fechaRentabilizacion || response.FechaRentabilizacion,
        mensajeError: this.firstDefined(response.mensajeError, response.MensajeError, '')
      };

      // ✅ Si del listado ya venía MensajeError, no lo pierdas
if (!this.archivoSeleccionado.mensajeError) {
  const fila = this.archivosLogs.find(a => (a.token || a.Token) === this.archivoSeleccionado.token);
  if (fila) {
    let msg = this.firstDefined(fila.MensajeError, fila.mensajeError, fila.Error, fila.error, null);
    if (typeof msg === 'string') msg = msg.trim();
    this.archivoSeleccionado.mensajeError = msg || '';
  }
}

      // Si quedó en K y no vino mensaje, tratamos de leerlo del log
      if (this.archivoSeleccionado.estadoFlujo === 'K' && !this.archivoSeleccionado.mensajeError) {
        try {
          const log = await materialService.getFileLog(this.archivoSeleccionado.token);
          this.archivoSeleccionado.mensajeError = this.firstDefined(log.mensajeError, log.MensajeError, '');
        } catch (_) {}
      }
    }
  } catch (error) {
    console.error("Error al obtener estado del archivo:", error);
    this.$notify && this.$notify({ type: 'error', message: 'No se pudo obtener el estado del archivo' });
  }
},
async onEmpresaSeleccionada() {
  console.log("Empresa seleccionada:", this.empresaSeleccionada);
  this.stopPollingEstado(); 
  // 👇 LIMPIAR DATOS DE LA GRILLA DE DETALLE
  this.archivoSeleccionado = null;
  this.archivoSeleccionadoToken = null;
  this.rentabilizacionData = [];
  this.initialRentabilizacionData = [];
  this.porcentajeAjuste = 0;
  this.currentPage = 1;
  this.totalPages = 1;
  
  this.archivosConsultados = false;
  this.archivosLogs = [];

  if (!this.empresaSeleccionada) {
    return;
  }

  await this.cargarLogsEmpresa(this.empresaSeleccionada);
},
  async cargarLogsEmpresa(idEmpresa) {
  try {
    const archivos = await materialService.getLogsFiles(idEmpresa);
    for (const archivo of archivos) {
  try {
    // 1️⃣ Mantén el mensaje original del DTO (no lo pises)
    let msgFromLogs = this.firstDefined(
      archivo.MensajeError,
      archivo.mensajeError,
      archivo.Error,
      archivo.error,
      null
    );
    if (typeof msgFromLogs === 'string') msgFromLogs = msgFromLogs.trim();

    // 2️⃣ Complementa con el estado actual
    const estado = await materialService.getEstadoFlujoArchivo(archivo.token);
    if (estado && (estado.success || estado.Success)) {
      archivo.estadoFlujo = this.normalizeEstado(estado.estadoFlujo || estado.EstadoFlujo);
      archivo.fechaRentabilizacion = estado.fechaRentabilizacion || estado.FechaRentabilizacion;

      // Si aún no hay mensaje, intenta con el del estado
      if (!msgFromLogs) {
        let msgFromEstado = this.firstDefined(estado.mensajeError, estado.MensajeError, null);
        if (typeof msgFromEstado === 'string') msgFromEstado = msgFromEstado.trim();
        msgFromLogs = msgFromEstado || msgFromLogs;
      }

      // Si sigue vacío y está en error (K/J/L), intenta desde getFileLog
      if (!msgFromLogs && ['K','J','L'].includes(archivo.estadoFlujo)) {
        try {
          const log = await materialService.getFileLog(archivo.token);
          let msgFromApi = this.firstDefined(log.mensajeError, log.MensajeError, null);
          if (typeof msgFromApi === 'string') msgFromApi = msgFromApi.trim();
          msgFromLogs = msgFromApi || msgFromLogs;
        } catch (_) {}
      }
    }

    // 3️⃣ Finalmente asigna el mensaje consolidado
    archivo.mensajeError = msgFromLogs || '';
  } catch (error) {
    console.warn(`No se pudo obtener estado para el archivo ${archivo.nombreXLSX}`);
  }
}
    this.archivosLogs = archivos;
    console.log('🔹 Archivos cargados:', this.archivosLogs);
  } catch (error) {
    console.error("Error cargando archivos:", error);
    this.archivosLogs = [];
  } finally {
    this.archivosConsultados = true;
  }
},
    },
    watch: {
  estadoActualArchivo(newVal) {
    if (newVal === 'R' || newVal === 'T') {
      this.fetchRentabilizacionData();
    }
    if (['K','J','L'].includes(newVal)) {
  this.stopPollingEstado();
}
  }
},
  };
  </script>
  
  <style>
  .search-input {
    width: 100%;
    max-width: 300px;
  }

  .table.table-sm td,
.table.table-sm th {
  vertical-align: middle !important;
}

.form-control {
    padding: 0.525rem 0.35rem;  
}

.inpt_result {
    min-width: 80px;
    max-width: 80px;
    padding: 0.4rem 0.5rem !important;
    -webkit-box-sizing: border-box !important;
    text-align: right !important;
    font-size: 0.7125rem !important;
  height: inherit !important;
}
.table td {
  white-space: nowrap;
}
input.form-control.inpt_result.text-right {
    height: 34px !important;
}

.table thead th {
    letter-spacing: 0px;
}
.size-th{
    white-space: normal !important;
    max-width: 100px;
}

.box-stat{
    max-width: 295px;
}
h4.text-primary.c-grey {
    font-size: 1.5rem;
    text-align: center;
}
p.text-muted {
    text-align: center !important;
    margin-bottom: 0;
}
.tabla-scroll {
  overflow-x: auto;
  width: 100%;
}
.tabla-scroll-fixed {
  position: relative;
  overflow-x: auto;
  width: 100%;
  border: 1px solid #dee2e6;
}
.table-fixed-columns {
  white-space: nowrap;
  margin-bottom: 0;
  table-layout: auto; /* Cambiado de fixed a auto */
}

.table-fixed-columns .fixed-col {
  position: sticky;
  left: 0;
  background-color: #fff;
  z-index: 10;
  border-right: 2px solid #dee2e6;
  min-width: 120px;
}

.table-fixed-columns thead .fixed-col {
  background-color: #f8f9fa;
  z-index: 11;
}

/* Ajustes para las columnas fijas específicas */
.table-fixed-columns .fixed-col:nth-child(1) { left: 0px;   min-width: 100px; display: none; } /* # (oculto)   */
.table-fixed-columns .fixed-col:nth-child(3) { left: 0px;   min-width: 110px; } /* SKU-INEXLINK  */
.table-fixed-columns .fixed-col:nth-child(4) { left: 110px; min-width: 120px; } /* part_number   */
.table-fixed-columns .fixed-col:nth-child(5) { left: 230px; min-width: 130px; } /* part_name     */
.table-fixed-columns .fixed-col:nth-child(6) { left: 360px; min-width: 170px; } /* descripcion   */
.table-fixed-columns .fixed-col:nth-child(7) { left: 530px; min-width: 100px; } /* brand_name    */
.table-fixed-columns .fixed-col:nth-child(8) { left: 630px; min-width: 90px;  } /* condicion     */

.scroll-col {
  min-width: 100px;
}


/* Encabezados sticky */
.table-fixed-columns thead .fixed-col {
  background-color: #f8f9fa;
  z-index: 100;
}

.thead-sticky {
  will-change: transform;
  position: relative;
}

.thead-sticky th {
  background-color: #f8f9fa;
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  border-top: none;
  border-bottom: none;
  box-shadow: inset 0 3px 0 #a0a3a5, inset 0 -3px 0 #a0a3a5;
}

/* Celdas sticky del cuerpo */
.table-fixed-columns tbody .fixed-col {
  background-color: #fff;
  z-index: 99;
}

/* Evita que el contenido se desborde visualmente */
.table-fixed-columns td,
.table-fixed-columns th {
  overflow: hidden;
}

.table-fixed-columns td.fixed-col,
.table-fixed-columns th.fixed-col {
  position: sticky;
}

.table-fixed-columns tr {
  overflow: hidden;
}

/* Estilo azul para el input de porcentaje */
#porcentaje-input {
  background-color: #e3f2fd;
  border-color: #1976d2;
  color: #1976d2;
}

#porcentaje-input:focus {
  background-color: #e3f2fd;
  border-color: #1976d2;
  box-shadow: 0 0 0 0.2rem rgba(25, 118, 210, 0.25);
}

/* Estilo azul para el label resultado */
#label_resultado {
  background-color: #e3f2fd !important;
  border-color: #1976d2 !important;
  color: #1976d2 !important;
  font-weight: 600;
}

/* Estilo para el span del porcentaje */
.input-group-text.blue-theme {
  background-color: #1976d2;
  border-color: #1976d2;
  color: white;
}

.d-flex.align-items-center.flex-wrap.gap-2.mb-3 {
    float: right;
}

.btn-icon-trash {
  width: 26px;
  height: 26px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-icon-trash i {
  font-size: 14px;
  line-height: 1;
}

.badge-clickable {
  cursor: pointer;
}
button.badge.badge-danger.badge-clickable {
    border: none;
}
button.badge.badge-danger.badge-clickable.mr-2 {
    display: none;
}
/* Badge ecommerce: Bootstrap no define esta clase */
.badge-ecommerce {
  background-color: #007bff;
  color: white;
}

/* Barra flotante de paginación */
.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.08);
}

.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}
.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  color: #212529;
}

/* Column search + sort */
.th-ordenable {
  cursor: pointer;
  user-select: none;
  vertical-align: top !important;
  padding: 4px 6px !important;
}
.tabla-archivos-cargados th,
.tabla-archivos-cargados td {
  font-size: 12px;
}
.tabla-archivos-cargados td .badge {
  font-size: 11px;
}
.th-search-input {
  width: 100%;
  min-width: 50px;
  padding: 2px 4px;
  font-size: 0.72rem;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-bottom: 2px;
  display: block;
  font-weight: normal;
  background: #fff;
}
.th-label {
  display: block;
  font-size: 0.72rem;
  white-space: nowrap;
}
  </style>